import React from 'react';
import { motion } from 'framer-motion';
export const FadeInSection = ({
  children,
  className = '',
  delay = 0
}: {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}) => {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    ease: 'easeOut',
    delay
  }} className={className} data-id="element-310">
      {children}
    </motion.div>;
};
export const CTAButton = ({
  text,
  href = 'https://sos.madestudio.store',
  className = '',
  fullWidth = false
}: {
  text: string;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}) => {
  return <motion.a href={href} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px rgba(192,57,43,0)', '0px 0px 20px rgba(192,57,43,0.4)', '0px 0px 0px rgba(192,57,43,0)']
  }} transition={{
    duration: 2.5,
    repeat: Infinity,
    repeatType: 'reverse'
  }} className={`
        inline-flex items-center justify-center 
        bg-brand-red text-white font-bold 
        py-4 px-8 rounded-full text-lg md:text-xl
        shadow-lg hover:bg-brand-redHover transition-colors
        border-b-4 border-red-900
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-311">
      {text}
    </motion.a>;
};
export const Divider = () => <div className="w-full flex justify-center py-12" data-id="element-312">
    <div className="w-24 h-px bg-brand-copper opacity-50 relative" data-id="element-313">
      <div className="absolute left-1/2 -translate-x-1/2 -top-1.5 w-3 h-3 rotate-45 border border-brand-copper opacity-50" data-id="element-314"></div>
    </div>
  </div>;